import { apiFetch } from "../api.js";
import type {
  CreateIncomeScheduleInput,
  IncomeSchedule,
  IncomeSchedulesListResponse,
  UpdateIncomeScheduleInput,
} from "./types.js";

export function listIncomeSchedules(
  args: { includeInactive?: boolean } = {},
): Promise<IncomeSchedulesListResponse> {
  const qs = new URLSearchParams();
  if (args.includeInactive) qs.set("include_inactive", "true");
  const tail = qs.toString();
  return apiFetch<IncomeSchedulesListResponse>(
    `/v1/income-schedules${tail ? `?${tail}` : ""}`,
  );
}

export function getIncomeSchedule(
  scheduleId: string,
): Promise<IncomeSchedule> {
  return apiFetch<IncomeSchedule>(`/v1/income-schedules/${scheduleId}`);
}

export function createIncomeSchedule(
  input: CreateIncomeScheduleInput,
): Promise<IncomeSchedule> {
  return apiFetch<IncomeSchedule>(`/v1/income-schedules`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateIncomeSchedule(
  scheduleId: string,
  input: UpdateIncomeScheduleInput,
): Promise<IncomeSchedule> {
  return apiFetch<IncomeSchedule>(`/v1/income-schedules/${scheduleId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteIncomeSchedule(scheduleId: string): Promise<void> {
  return apiFetch<void>(`/v1/income-schedules/${scheduleId}`, {
    method: "DELETE",
  });
}
